"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CropIcon = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const CropIcon = props => (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({}, props, { viewBox: "0 0 100 100" }),
    react_1.default.createElement("path", { d: "M93.22,81.22H18.78V6.78a4,4,0,0,1,4-4h0a4,4,0,0,1,4,4V73.22H93.22a4,4,0,0,1,4,4h0A4,4,0,0,1,93.22,81.22Z" }),
    react_1.default.createElement("path", { d: "M6.78,18.78h8v8h-8a4,4,0,1,1,0-8Z" }),
    react_1.default.createElement("polygon", { points: "81.22 18.78 81.22 69.22 73.22 69.22 73.22 26.78 30.78 26.78 30.78 18.78 81.22 18.78" }),
    react_1.default.createElement("path", { d: "M73.22,85.22h8v8a4,4,0,0,1-8,0Z" })));
exports.CropIcon = CropIcon;
exports.default = exports.CropIcon;
